import React from 'react';
import { useSelector } from 'react-redux';

interface TracksPlayerProps {}

export const TracksPlayer: React.FC<TracksPlayerProps> = ({}) => {
  const commonValue = useSelector((state: any) => state.common);
  return <audio id='bg-audio' src={commonValue.audio} autoPlay loop></audio>;
};
